/**
 * Wegic 内部消息标签名。
 */
export const WEGIC_TAGS = {
  // 自定义组件标签
  TRIAL_PAY_BUTTON: 'trial-pay-button',
  RUNTIME_ERROR: 'wg-runtime-error',
  CODE_ERROR: 'wg-code-error',
  SITE_AUDIT_ISSUES: 'wg-site-audit-issues',
  DOWNLOAD_CODE: 'wegic-download-code',
  // 内部标签（渲染时过滤）
  WEGIC_AUDIT_DETAIL: 'wegic-audit-detail',
  CLOUD_CONFIRM: 'wegic-cloud-confirm',
  SHORTCUT_SUGGESTION_PROMPT: 'wegic-shortcut-prompt',
  OPTIONS: 'wegic-options',
  USER_IMAGES: 'wegic-user-images',
  WEGIC_PAGE_STRUCTURE: 'wegic-page-structure',
  WEGIC_SUMMARY_LIST: 'wegic-summary-list',
  PROJECT_LAUNCH_ORDER: 'wegic-project-launch',
  WEGIC_ASSETS_FORM: 'wegic-asset-form',
  WEGIC_REMINDER: 'wegic-reminder',
  USER_UPLOADED_IMAGES: 'user-uploaded-images',
} as const;

export type WegicTagName = typeof WEGIC_TAGS[keyof typeof WEGIC_TAGS];

/**
 * 需要从消息显示内容中过滤的内部标签。
 */
export const INTERNAL_TAGS: WegicTagName[] = [
  WEGIC_TAGS.SHORTCUT_SUGGESTION_PROMPT,
  WEGIC_TAGS.OPTIONS,
  WEGIC_TAGS.USER_IMAGES,
  WEGIC_TAGS.WEGIC_REMINDER,
  WEGIC_TAGS.WEGIC_AUDIT_DETAIL,
  WEGIC_TAGS.USER_UPLOADED_IMAGES,
];

/** 已废弃的旧标签名，仅用于兼容历史消息的过滤显示。 */
export const LEGACY_INTERNAL_TAGS = [
  'wegic-shortcut-suggestion-prompt',
  'wegic-shortcut-suggestion-id',
];
